import React from 'react'
import classNames from 'classnames'
import styles from './FJButtonCircleIcon.module.less'
import InlineSVG from "react-inlinesvg";

function FJButtonCircleIcon(props) {
  let {
    icon,
    className,
    onClick,
    onMouseOver,
    type,
  } = props;

  let CN = classNames(styles.box, className, styles[type]);
  return (
    <div className={CN} onClick={onClick} onMouseOver={onMouseOver}>
      <InlineSVG src={icon} />
    </div>
  );
}

export default FJButtonCircleIcon;
